import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SnsIcon = ({ link, icon }) => (
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    style={{ marginLeft: 12, color: 'inherit' }}
  >
    <FontAwesomeIcon icon={icon} />
  </a>
)

function Footer() {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
      <Box sx={{ maxWidth: '1000px', width: '100%' }}>
        <Divider sx={{ mb: 1 }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1
          }}
        >
          <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
            © Hyunjin Jae, 2019 - 2026
          </Typography>
          <Box>
            <SnsIcon link="mailto:hyunjineeey@gmail.com" icon="fa-solid fa-envelope" />
            <SnsIcon link="https://www.linkedin.com/in/hyunjineeey/" icon="fa-brands fa-linkedin" />
            <SnsIcon link="https://github.com/hyunjineeey" icon="fa-brands fa-github" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
